import type { ReportColumnType, ReportResponse } from '../../../modules/reportsApi/catalog/report-catalog'

export type ReportChartType = 'bar' | 'line' | 'pie'

export interface ReportChartConfig {
    dimensionKey: string
    valueKey: string
    type: ReportChartType
}

// modo de exibição da tela de relatório — persistido globalmente em window.store.reportViewMode
// (ver store.service.ts), não por relatório: a escolha vale pra qualquer tela que o usuário abrir depois
export type ReportViewMode = 'report' | 'report-chart' | 'chart'

export const REPORT_VIEW_MODE_OPTIONS: { value: ReportViewMode; label: string }[] = [
    { value: 'report', label: 'Relatório' },
    { value: 'report-chart', label: 'Relatório + Gráfico' },
    { value: 'chart', label: 'Gráfico' },
]

// valor "sintético" pro select de Valor: em vez de ler uma coluna numérica, agrupa as linhas pela
// dimensão escolhida e conta quantas vezes cada valor de dimensão aparece — único jeito de montar gráfico
// pra relatórios sem nenhuma coluna numérica (ex.: listagens simples)
export const OCCURRENCES_VALUE_KEY = '__occurrences__'

export const NUMERIC_COLUMN_TYPES: ReportColumnType[] = ['int', 'float', 'currency', 'percent']
const DIMENSION_TYPES: ReportColumnType[] = ['string', 'date', 'datetime', 'time', 'phone', 'email']

// infere dimensão/valor/tipo a partir do próprio contrato do relatório (ReportColumn.type) — sem exigir
// nenhuma config nova no backend. Cobre a maioria dos relatórios já padronizados; casos que fujam disso
// (ex.: mais de uma coluna numérica relevante) o usuário troca manualmente pelos selects do zact do gráfico
export function inferChartConfig(response: ReportResponse): ReportChartConfig | null {
    if (!response?.columns?.length) return null
    const dimension = response.columns.find((col) => DIMENSION_TYPES.includes(col.type) && col.show !== false)
    if (!dimension) return null
    // de trás pra frente: colunas numéricas mais à direita costumam ser os totais/resultado do relatório,
    // enquanto as da esquerda tendem a ser quantidades/valores intermediários usados no cálculo. Relatórios
    // sem nenhuma coluna numérica caem no padrão [Ocorrências] (contagem por dimensão) em vez de não terem gráfico
    const value = [...response.columns].reverse().find((col) => NUMERIC_COLUMN_TYPES.includes(col.type) && col.show !== false)
    const type: ReportChartType = dimension.type === 'date' || dimension.type === 'datetime' ? 'line' : 'bar'
    return { dimensionKey: dimension.key, valueKey: value?.key ?? OCCURRENCES_VALUE_KEY, type }
}
